module.exports = "/_next/static/images/2af5a26dfa3986d8988ea7bc4a507d65-limit-lg.png";